import React from 'react';

import { useAppSelector } from '@src/hooks';

import { LiquidityDeposit } from './LiquidityDeposit';
import { StandardDeposit } from './StandardDeposit';

export const Deposit: React.FC<{ is_confirmed: boolean }> = ({
    is_confirmed,
}) => {
    const { current_pool, pools } = useAppSelector((state) => state.staking);

    const { type } = pools.find(({ id }) => id === current_pool);

    switch (type) {
        case 'liquidity':
            return <LiquidityDeposit is_confirmed={is_confirmed} />;
        case 'legacy-liquidity':
            return <LiquidityDeposit is_confirmed={is_confirmed} />;
        default:
            return <StandardDeposit is_confirmed={is_confirmed} />;
    }
};
